export function handleError(code, internalErrorMessage, notFoundErrorMessage) {
    let message = '';
   switch(code.toString()) {
     case '409':
      message = internalErrorMessage;
      break;
     case '401':
      message = internalErrorMessage;
      break;
     case '500':
       message = internalErrorMessage;
       break;
    case '404':
       message = notFoundErrorMessage;
       break;
    default:
       message = '';
       break;
   }
   
  return message;
  }
  
